import { render, staticRenderFns } from "./lottery-music.vue?vue&type=template&id=1eac4570&scoped=true&"
import script from "./lottery-music.vue?vue&type=script&lang=ts&"
export * from "./lottery-music.vue?vue&type=script&lang=ts&"
import style0 from "./lottery-music.vue?vue&type=style&index=0&id=1eac4570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eac4570",
  null
  
)

export default component.exports